"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RecentSearchType;
(function (RecentSearchType) {
    RecentSearchType[RecentSearchType["Date"] = 0] = "Date";
    RecentSearchType[RecentSearchType["Text"] = 1] = "Text";
    RecentSearchType[RecentSearchType["Mixed"] = 2] = "Mixed";
})(RecentSearchType = exports.RecentSearchType || (exports.RecentSearchType = {}));
